import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './Sort.translations'

type RateSortOption =
  | '-relevance_alt'
  | '-created_at'
  | '-global_rate'
  | 'global_rate'

export function getSortOptions() {
  const i18n = useI18n()

  const list: Array<{
    label: string
    value: RateSortOption
  }> = [
    {
      label: i18n(translations.relevance),
      value: '-relevance_alt',
    },
    {
      label: i18n(translations.recentReviews),
      value: '-created_at',
    },
    {
      label: i18n(translations.rateDescending),
      value: '-global_rate',
    },
    {
      label: i18n(translations.rateAscending),
      value: 'global_rate',
    },
  ]

  return {
    list,
    defaultOption: '-relevance_alt',
  }
}
